import { isForeSight, portaleConfig } from "@/portaliConfig";
import colors from "@/theme/base/colors";
import { ReactNode } from "react";
import Box from "../Box";
import Typography from "../Typography";

type CoverLayoutProps = {
  color?:
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "dark"
    | "light";
  header?: ReactNode;
  title?: string;
  description?: string;
  image?: string;
  top?: number;
  children?: ReactNode;
  showLogo?: boolean;
  bigContent?: boolean;
  noBackground?: boolean;
};

function CoverLayout(props: CoverLayoutProps) {
  const {
    color = "info",
    header = "",
    title = "",
    description = "",
    image,
    top = props.showLogo ? 10 : 20,
    children,
    showLogo = false,
    bigContent = false,
    noBackground = false,
  } = props;

  return (
    <Box
      width="100vw"
      height="100%"
      minHeight="100vh"
      bgColor="white"
      sx={{ overflowX: "hidden", display: "flex", flexDirection: "column" }}
    >
      <Box
        width="100vw"
        bgColor="white"
        sx={{
          display: "flex",
          flexDirection: "row",
          p: 4,
          alignItems: "center",
          justifyContent: { xs: "center", md: "space-between" },
        }}
      >
        {!noBackground && (
          <div style={{ pointerEvents: "none" }}>
            {portaleConfig.coverBottomLeft}
          </div>
        )}

        <Box>
          <img
            src={portaleConfig.aziendaLogo}
            height="64px"
            alt={portaleConfig.aziendaNome}
          />
        </Box>

        {portaleConfig.coverTopRight}
      </Box>

      <Box
        width="100vw"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflowX: "hidden",
          flex: 1,
          backgroundColor: noBackground ? undefined : colors.primary.main,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: showLogo ? 8 : 0,
            p: 1,
            minWidth: "280px",
            maxWidth: bigContent ? "1000px" : "400px",
            width: "100%",

            //foresight
            ...(isForeSight
              ? { backgroundColor: "#545095", borderRadius: "25px", p: 4 }
              : null),
          }}
        >
          {showLogo && (
            <img
              src={portaleConfig.portaleLogoBackgroundColored}
              style={{ maxWidth: "100%", maxHeight: 200 }}
              alt={portaleConfig.portaleNome}
            />
          )}

          <Box
            pt={header || description ? 8 : 0}
            sx={{ display: "flex", flexDirection: "column", flex: 1 }}
          >
            {!header ? (
              <Typography
                variant="h4"
                fontWeight="regular"
                sx={{ color: colors.secondary.main, textAlign: "center" }}
              >
                {description}
              </Typography>
            ) : (
              header
            )}
          </Box>
          <Box pt={3} sx={{ minWidth: 300 }}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default CoverLayout;
